import { GeoJson } from '@ais-ui/api-spec/shapes';
import React, { useState } from 'react';
import { useLocalization } from '@ais-ui/locale-management';
import { usePermissions } from '../../Permissions/PermissionsProvider';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical } from 'react-icons/pi';
import { CreateShape } from '../Mutations/CreateShape';
import { ShowLabelDropdownButton } from './ShowLabelDropdownButton';
import { ExportShapeDropdownMenu } from './ExportShapeDropdownMenu';
import { CreateBufferDropdownButton } from './CreateBufferDropdownButton';
import { ShowRoutesTableDropdownButton } from './ShowRoutesTableDropdownButton';
import { useOwnershipCheck } from '../../utils/useOwnershipCheck';

export const ShapeDropdownMenu = ({
  shape,
  onDeleteShow,
  onEdit,
  className,
}: {
  shape: GeoJson;
  onDeleteShow: () => void;
  onEdit: (event: React.FormEvent) => void;
  className?: string;
}) => {
  const { messages } = useLocalization();
  const [open, setOpen] = useState<boolean>(false);
  const [openPopoverBuffer, setOpenPopoverBuffer] = useState<boolean>(false);
  const [showCreateDialog, setShowCreateDialog] = useState<boolean>(false);

  const [bufferShape, setBufferShape] = useState<GeoJson | undefined>(
    undefined,
  );

  const permissions = usePermissions();
  const { isOwner } = useOwnershipCheck();

  const canEditOrDelete = isOwner(shape?.properties);

  const onOpenChangeDropdown = (open: boolean) => {
    setOpen(open);
    setOpenPopoverBuffer(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={onOpenChangeDropdown}>
      <DropdownMenuTrigger asChild className={className}>
        <Button
          id={`${shape.properties.name ?? shape.properties.id ?? 'shape'}-dropdown-button`}
          size="icon"
          variant="ghost"
          className="size-8"
        >
          <PiDotsThreeVertical className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <ShowLabelDropdownButton shape={shape}></ShowLabelDropdownButton>
        {permissions.pilot &&
          (shape?.geometry?.type === 'Polygon' ||
            (shape?.geometry?.type === 'Point' &&
              !shape?.properties?.radius)) && (
            <ShowRoutesTableDropdownButton
              shape={shape}
            ></ShowRoutesTableDropdownButton>
          )}
        <ExportShapeDropdownMenu shape={shape}></ExportShapeDropdownMenu>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onEdit} disabled={!canEditOrDelete}>
          {messages.genericEdit}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDeleteShow} disabled={!canEditOrDelete}>
          {messages.genericDelete}
        </DropdownMenuItem>
        {shape?.geometry?.type === 'LineString' && (
          <CreateBufferDropdownButton
            shape={shape}
            setOpen={setOpen}
            setOpenPopoverBuffer={setOpenPopoverBuffer}
            setShowCreateDialog={setShowCreateDialog}
            setBufferShape={setBufferShape}
            openPopoverBuffer={openPopoverBuffer}
          ></CreateBufferDropdownButton>
        )}
      </DropdownMenuContent>
      {showCreateDialog && (
        <CreateShape
          setShowDialog={setShowCreateDialog}
          geometryType="Polygon"
          shape={bufferShape}
          startInDrawMode={false}
        ></CreateShape>
      )}
    </DropdownMenu>
  );
};
